module.exports = __webpack_public_path__ + "static/img/legend_english_dark.20b3253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_english_dark.png
// module id = wWt0
// module chunks = 94